import styled from "styled-components";

export default styled.div `
  
     .ant-transfer-list {
        width: calc(50% - 57px);
     }
    
    .transferHeader {
        width: 100%;
    
       .headerEntry {
          display: inline-block;
          width: calc(50% - 57px);
          padding-left: 16px;
          margin: 12px 0;
          
          &:last-child {
             margin-left: 112px;
          }
       }
    }
    
`;
